module.exports = __webpack_public_path__ + "static/media/title_11.25551247.svg";